import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseTranslateModule } from '@nx-ahs/base-translate';
import { IonicModule } from '@ionic/angular';
import { ValidationListDisplayComponent } from '@nx-ahs/base-ahs-controls/reactive';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { CollectorModule } from '@nx-ahs/script-collector';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { RecaptchaComponent } from './recaptcha.component';
import { RecaptchaModule } from 'ng-recaptcha-2';

@NgModule({
	declarations: [RecaptchaComponent],
	imports: [
		CommonModule,
		FormsModule,
		IonicModule,
		ValidationListDisplayComponent,
		BaseTranslateModule,
		MatFormFieldModule,
		MatIconModule,
		MatInputModule,
		CollectorModule,
		FlexLayoutModule,
		ReactiveFormsModule,
		RecaptchaModule
	],
	exports: [RecaptchaComponent]
})
export class RecaptchaComponentModule {}
